// extracted by mini-css-extract-plugin
export default {"root":"pages_root__fvy9V","sidebar":"pages_sidebar__kHAfx","contentArea":"pages_contentArea__pIjvn","hidden":"pages_hidden__xxcMc"};